import { MatPaginatorIntl } from '@angular/material';
import { ApiEvents, TranslateService } from 'vas-mobile-api';

const paginatorIntl = new MatPaginatorIntl();

function rangeLabel(translateService: TranslateService) {

    const till = translateService.translate('LABEL_FROM');
    const arabicRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) { return `0 ${till} ${length}`; }

        length = Math.max(length, 0);

        const startIndex = page * pageSize;

        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} ${till} ${length}`;
    };
    return arabicRangeLabel;
}

function setLabels(translateService: TranslateService) {
    paginatorIntl.itemsPerPageLabel = translateService.translate('LABEL_ITEM_PER_PAGE');
    paginatorIntl.nextPageLabel = translateService.translate('LABEL_NEXT_PAGE');
    paginatorIntl.previousPageLabel = translateService.translate('LABEL_PREVIOUS_PAGE');
    paginatorIntl.getRangeLabel = rangeLabel(translateService);
}

export function getTranslationsPaginatorIntl(translateService: TranslateService, apiEvents: ApiEvents) {

    paginatorIntl.itemsPerPageLabel = 'Initial';
    apiEvents.translateChanged().subscribe(() => {
        setLabels(translateService);
    });

    apiEvents.ready().then(() => {
        setLabels(translateService);
    });

    return paginatorIntl;
}
